import View from './view/CanViewIrInitialState'

const { Record } = require('immutable');

export default Record({
    view: View()
});